/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveWalletRequestBody
 */
export interface RemoveWalletRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveWalletRequestBody
     */
    walletId: string;
}

/**
 * Check if a given object implements the RemoveWalletRequestBody interface.
 */
export function instanceOfRemoveWalletRequestBody(value: object): value is RemoveWalletRequestBody {
    if (!('walletId' in value) || value['walletId'] === undefined) return false;
    return true;
}

export function RemoveWalletRequestBodyFromJSON(json: any): RemoveWalletRequestBody {
    return RemoveWalletRequestBodyFromJSONTyped(json, false);
}

export function RemoveWalletRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveWalletRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'walletId': json['walletId'],
    };
}

export function RemoveWalletRequestBodyToJSON(json: any): RemoveWalletRequestBody {
    return RemoveWalletRequestBodyToJSONTyped(json, false);
}

export function RemoveWalletRequestBodyToJSONTyped(value?: RemoveWalletRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'walletId': value['walletId'],
    };
}

